import React from "react";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import CostCenters from "./CostCenters";
import { sto } from "../../../../Context/InshData";

export default function CostCentersCon() {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `Costcenter`
  } else {
    Urls = `Costcenter?db_name=${sto?.db_name}`
  }
  const { data, fetching, fetchURL } = useFetchURL({
    ...{
      url: uri + Urls,
    },
  });

  if (!data || fetching) return <LoadingPage />;

  return <CostCenters {...{ data, fetchURL }} />;
}
